import { useTranslation } from "react-i18next";
import { ArrowDown } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ScrollToBottomButtonProps {
  visible: boolean;
  onClick: () => void;
}

export const ScrollToBottomButton = ({
  visible,
  onClick,
}: ScrollToBottomButtonProps) => {
  const { t } = useTranslation(["common"]);
  if (!visible) return null;
  return (
    <Button
      type="button"
      variant="outline"
      size="icon-sm"
      onClick={onClick}
      aria-label={t("common:a11y.scroll_to_latest_message")}
      className="surface-frosted animate-rise-in absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full text-primary shadow-md"
    >
      <ArrowDown className="size-4" />
    </Button>
  );
};
